export default "<m-plane\n    y=\"5\"\n    width=\"5\"\n    height=\"7\"\n    color=\"blue\"\n></m-plane>\n";